import React, {useEffect} from 'react';
import TimerCounter from "./timerCounter";
import {useModal} from "../../contexts/ModalContext"
import {useGetAccreditationOtpMutation} from "../../features/apiSlice/accreditation-otp";

const Counter = () => {
    const {modalOption, setModalOption} = useModal()

    useEffect(() => {
        if (modalOption > 0) {
            setTimeout(() => {
                setModalOption((modalOption) => modalOption - 1);
            }, 1000)
        }
    }, [modalOption])

    return (<TimerCounter counter={modalOption}/>)
};

export default Counter;